import { useState } from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import { DropDown, TextBox } from '../../shared/controls/form';

const validationSchema = Yup.object().shape({
  accountName: Yup.string().required('Account Name is required'),
  parentAccount: Yup.string().required('Parent Account is required'),
  phone: Yup.string()
    .required('Phone is required')
    .matches(/^\(?([0-9]{3})\)?[-.●]?([0-9]{3})[-.●]?([0-9]{4})$/, 'Phone number is not valid'),
  website: Yup.string()
    .required('Website is required')
    .matches(
      /^((https?:\/\/)?([a-zA-Z0-9-]+\.)+(@|com|net|org|edu|gov|mil|biz|info|mobi|name|aero|asia|jobs|museum)\b)((\/[a-zA-Z0-9-._~:\/?#\[\]@!$&'()*+,;=]*)?)$/,
      'Invalid website URL'
    ),
  annualRevenue: Yup.string().required('Annual Revenue is required'),
  billingCountry: Yup.string().required('Billing Country is required'),
});

const AddCallsForm = ({ handleCloseAddForm, handleFormSubmit, callData, open, callList }) => {
  const [formData, setFormData] = useState(callData);
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);

  const handleChangeForm = (e) => {
    const { name, value } = e.target;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));
    const convertedValue = value;
    setFormData({
      ...formData,
      [name]: convertedValue,
    });
    setFormEdited(true);
  };

  const handleSubmit = async (formData) => {
    try {
      await validationSchema.validate(formData, { abortEarly: false });

      handleFormSubmit(formData);
    } catch (error) {
      const fieldErrors = {};
      error.inner.forEach((err) => {
        fieldErrors[err.path] = err.message;
      });
      setErrorMsg(fieldErrors);
      console.error('Validation Error:', fieldErrors);
    }
  };

  const handleDropdownChange = (selectedId, e, name, displayName, flag) => {
    const selectedValue = e.currentTarget.textContent;

    // Update formData with the selected value for the dropdown
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
      [displayName]: undefined,
    }));
    setFormData({
      ...formData,
      [name]: selectedId,
      [displayName]: selectedValue,
    });

    setFormEdited(true);
  };

  return (
    <div className="modal-form">
      <div
        className={`modal fade ${open ? 'show' : ''}`}
        id="callModal"
        tabIndex="-1"
        aria-labelledby="callModalLabel"
        aria-hidden="true"
        style={{
          display: open ? 'flex' : 'none',
          justifyContent: 'center',
        }}
      >
        <div className="modal-dialog" style={{ width: '1080px' }}>
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fs-5" id="accountModalLabel">
                {/* {callData.type === 'add' ? 'New Call' : 'Update Call'}  */}
                Schedule a Call
              </h5>
              <div className="modal_btn_group">
                <button type="button" className="view_screen">
                  <svg
                    width="18px"
                    height="18px"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M3 4C3 3.44772 3.44772 3 4 3H8C8.55228 3 9 3.44772 9 4C9 4.55228 8.55228 5 8 5H6.41421L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L5 6.41421V8C5 8.55228 4.55228 9 4 9C3.44772 9 3 8.55228 3 8V4ZM16 3H20C20.5523 3 21 3.44772 21 4V8C21 8.55228 20.5523 9 20 9C19.4477 9 19 8.55228 19 8V6.41421L15.7071 9.70711C15.3166 10.0976 14.6834 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L17.5858 5H16C15.4477 5 15 4.55228 15 4C15 3.44772 15.4477 3 16 3ZM9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L6.41421 19H8C8.55228 19 9 19.4477 9 20C9 20.5523 8.55228 21 8 21H4C3.44772 21 3 20.5523 3 20V16C3 15.4477 3.44772 15 4 15C4.55228 15 5 15.4477 5 16V17.5858L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929ZM14.2929 14.2929C14.6834 13.9024 15.3166 13.9024 15.7071 14.2929L19 17.5858V16C19 15.4477 19.4477 15 20 15C20.5523 15 21 15.4477 21 16V20C21 20.5523 20.5523 21 20 21H16C15.4477 21 15 20.5523 15 20C15 19.4477 15.4477 19 16 19H17.5858L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z"
                      fill="#000000"
                    />
                  </svg>
                </button>
                <div className="option_menu">
                  <div className="dropdown">
                    <button
                      className="three-dots-btn"
                      id="dropdownMenuButton"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="1.1"
                      >
                        <circle cx="12" cy="5" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="19" r="2"></circle>
                      </svg>
                    </button>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                      <li>
                        <a className="dropdown-item" href="#">
                          Edit
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Delete
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          Settings
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <button
                  type="button"
                  className="custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={handleCloseAddForm}
                ></button>
              </div>
            </div>
            <div className="modal-body">
              <Formik
                initialValues={formData}
                onSubmit={(values) => handleSubmit(values)}
                validationSchema={validationSchema}
              >
                <Form>
                  <div className="form">
                    <>
                      <div className="subHeading">Call Information</div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Call To'}
                          name={'callTo'}
                          placeholder={'Call To'}
                          value={formData.callTo}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.callTo}
                        />
                      </div>

                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Related To'}
                          name={'relatedTo'}
                          placeholder={'Enter Related To'}
                          value={formData.relatedTo}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.relatedTo}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Call Type '}
                          name={'callType'}
                          placeholder={'Enter Call Type '}
                          value={formData.callType}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.callType}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Outgoing Call Status '}
                          name={'outgoingCallStatus'}
                          placeholder={'Enter Outgoing Call Status '}
                          value={formData.outgoingCallStatus}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.outgoingCallStatus}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Call Start Time'}
                          name={'callStartTime'}
                          placeholder={'Enter Call Start Time '}
                          value={formData.callStartTime}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.callStartTime}
                        />
                      </div>
                      <div className="input-container">
                        <DropDown
                          label={'Call Owner'}
                          name={'callOwnerId'}
                          displayName={'callOwner'}
                          // isRequired={true}
                          placeholder={'Select Call Owner'}
                          value={formData.callOwner}
                          handleSelect={handleDropdownChange}
                          options={callList}
                          optionKeys={['id', 'name']}
                          errormsg={errormsg.callOwner}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Subject'}
                          name={'subject'}
                          placeholder={'Enter Subject'}
                          value={formData.subject}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.subject}
                        />
                      </div>
                      <div className="input-container">
                        <DropDown
                          label={'Reminder'}
                          name={'reminderId'}
                          displayName={'reminder'}
                          // isRequired={true}
                          placeholder={'Select Reminder'}
                          value={formData.reminder}
                          handleSelect={handleDropdownChange}
                          options={callList}
                          optionKeys={['id', 'name']}
                          errormsg={errormsg.reminderId}
                        />
                      </div>
                      <div className="subHeading">Purpose of Outgoing Call</div>
                      <div className="input-container">
                        <DropDown
                          label={'Call Purpose'}
                          name={'callPurposeId'}
                          displayName={'callPurpose'}
                          // isRequired={true}
                          placeholder={'Select Call Purpose'}
                          value={formData.callPurpose}
                          handleSelect={handleDropdownChange}
                          options={callList}
                          optionKeys={['id', 'name']}
                          errormsg={errormsg.callPurposeId}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Call Agenda'}
                          name={'callAgenda'}
                          placeholder={'Enter Call Agenda'}
                          value={formData.callAgenda}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.callAgenda}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Created by System'}
                          name={'createdBySystem'}
                          placeholder={'Enter System'}
                          value={formData.createdBySystem}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.createdBySystem}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Created by System ID'}
                          name={'createdBySystemId'}
                          placeholder={'Enter System ID'}
                          value={formData.createdBySystemId}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.createdBySystemId}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Modified by System'}
                          name={'modifiedBySystem'}
                          placeholder={'Enter Modified System'}
                          value={formData.modifiedBySystem}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.modifiedBySystem}
                        />
                      </div>
                      <div className="input-container">
                        <TextBox
                          // isRequired={true}
                          label={'Modified by System ID'}
                          name={'modifiedBySystemId'}
                          placeholder={'Enter Modified System ID'}
                          value={formData.modifiedBySystemId}
                          handleChange={handleChangeForm}
                          errormsg={errormsg.modifiedBySystemId}
                        />
                      </div>
                    </>
                  </div>
                </Form>
              </Formik>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-primary"
                data-bs-dismiss="modal"
                onClick={handleCloseAddForm}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  handleSubmit(formData);
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddCallsForm;
